module.exports = __webpack_public_path__ + "static/media/122.192c827b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/122.jpg
// module id = 932
// module chunks = 0